import React from "react";
import { Routes, Route, Navigate, useLocation, matchPath, Link, useSearchParams } from "react-router-dom";
import { routes } from "routes";
import logoSvg from "assets/svg/logo.svg";
import BackIcon from "components/icons/BackIcon";
import NotFound from "views/errors/404";

export default function Volunteer(props) {
  const location = useLocation();
  const [queryParams] = useSearchParams();
  const token = queryParams.get('token');
  const getRoutes = (routes) => {
    if (!token) return;

    return routes.map((prop, key) => {
      if (prop.layout === "/volunteer") {
        return (
          <Route path={`${prop.path}`} element={prop.component} key={key} />
        );
      }

      return null;
    });
  };
  document.documentElement.dir = "ltr";

  const isDetailsPage = matchPath("/volunteer/services/:id", location.pathname);
  
  return (
    <div className="h-full w-full bg-lightPrimary dark:bg-background-900 dark:text-white py-4">
      {/* Navbar & Main Content */}
      <div className="h-full w-full m-auto max-w-[1080px] font-dm">
        {/* Main Content */}
        <main className="flex-none transition-all">
          <div className={`flex flex-row mb-4 mx-4 items-center ${isDetailsPage && 'md:bg-white md:px-6 md:py-2 md:rounded-2xl md:dark:bg-navy-700'}`}>
            <div className="flex-1">
              {!isDetailsPage && <img alt="Atrium" className="h-10 flex-1" src={logoSvg} />}
              {isDetailsPage && <Link to={`/volunteer/my-services?token=${token}`} className="inline-block text-gray-800 dark:text-white p-2"><BackIcon/></Link>}
            </div>
            {/* <div>
              <Dropdown
                button={
                  <img
                    className="select-none h-10 w-10 rounded-full"
                    src={avatar}
                    alt="Elon Musk"
                  />
                }
                children={
                  <div className="flex h-max w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat pb-4 shadow-atrium shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
                    <div className="mt-3 ml-4">
                      <div className="flex items-center gap-2">
                        <p className="text-sm font-bold text-navy-700 dark:text-white">
                          👋 Hey, Adela
                        </p>{" "}
                      </div>
                    </div>
                    <div className="mt-3 h-px w-full bg-gray-200 dark:bg-white/20 " />

                    <div className="mt-3 ml-4 flex flex-col">
                      <a
                        href=" "
                        className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                      >
                        Profile Settings
                      </a>
                      <a
                        href=" "
                        className="mt-3 text-sm text-gray-800 dark:text-white hover:dark:text-white"
                      >
                        Newsletter Settings
                      </a>
                    </div>
                  </div>
                }
                classNames={"py-2 top-8 -left-[180px] w-max"}
              />
            </div> */}
          </div>

          {/* Routes */}
          <div className="flex flex-col mx-auto min-h-[calc(100vh_-_88px)]">
            <Routes>
              {getRoutes(routes)}
              <Route
                path="/"
                element={<Navigate to="/volunteer/my-services" replace />}
              />
              <Route path="*" element={<NotFound/>} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
}
